export default {
  'menu.login': 'Login',
  'menu.account.logout': 'Logout',
  'menu.account.switch-admin': 'Switch Role',
  'menu.merchant': 'Merchant Management',
  'menu.merchant.brand': 'Brand Management',
  'menu.merchant.store': 'Store Management',
  'menu.merchant.wechatSpConfig': 'WeChat SP Config',
  'menu.merchant.alipaySpConfig': 'Alipay SP Config',
  'menu.merchant.subMerchant': 'Sub Merchant Config',
  'menu.system': 'System Management',
  'menu.system.menu': 'Menu Management',
  'menu.userManagement': 'User Management',
  'menu.userManagement.role': 'Role Management',
  'menu.userManagement.publicRole': 'Public Role Management',
  'menu.userManagement.admin': 'Admin Management',
  'menu.userManagement.coach': 'Coach Management',
  'menu.equipment': 'Equipment Management',
  'menu.equipment.table': 'Table Management',
  'menu.equipment.device': 'Device Management',
  'menu.equipment.scoreboardCode': 'Scoreboard Code',
  'menu.match': 'Match Management',
  'menu.match.list': 'Match List',
  'menu.match.detail': 'Match Detail',
  'menu.product': 'Product Management',
  'menu.product.category': 'Product Category',
  'menu.product.list': 'Product List',
  'menu.order': 'Order Management',
  'menu.order.tableOrder': 'Order List',
  'menu.order.refund': 'Refund Management',
  'menu.openPlatform': 'Open Platform',
  'menu.openPlatform.openApp': 'App Configuration',
  'menu.openPlatform.callbackLogs': 'Callback Logs',
  'menu.openPlatform.apiLogs': 'API Logs',
  'menu.finance': 'Finance Center',
  'menu.finance.profitReceiver': 'Profit Receiver',
  'menu.finance.brandProfitPreset': 'Brand Profit Preset',
  'menu.finance.storeProfitRule': 'Store Profit Rule',
  'menu.finance.profitSharing': 'Profit Sharing Record',
  'menu.finance.profitSharingReturn': 'Profit Sharing Return',
  'menu.finance.fundAccount': 'Fund Account',
  'menu.statistics': 'Business Analytics',
  'menu.statistics.orderRevenue': 'Order Revenue Statistics',
};
